// "Guess It!" content — a progressive-clue guessing game. Each item has FOUR
// clues that go from cryptic to obvious. The host reveals them one at a time;
// the fewer clues used, the more points the guessing team earns (4 → 1). Broad
// and India-friendly: people, places, monuments, festivals, sport, Bollywood.
export const GUESS_IT_ITEMS = [
  {
    answer: 'Taj Mahal', category: 'Monument',
    clues: [
      'I am over 370 years old.',
      'A Mughal emperor built me in memory of his queen.',
      'I sit on the banks of the Yamuna in Agra.',
      'I am a white marble monument — a symbol of love.',
    ],
  },
  {
    answer: 'Sachin Tendulkar', category: 'Cricket',
    clues: [
      'I was born in Mumbai in 1973.',
      'I made my India debut at just 16.',
      'I hold the record for 100 international centuries.',
      'Fans call me the "God of Cricket".',
    ],
  },
  {
    answer: 'A. P. J. Abdul Kalam', category: 'Personality',
    clues: [
      'I was born in Rameswaram, Tamil Nadu.',
      'I was a scientist long before I entered public life.',
      'I am known as the "Missile Man of India".',
      'I served as India’s 11th President.',
    ],
  },
  {
    answer: 'Diwali', category: 'Festival',
    clues: [
      'I am celebrated across India and beyond.',
      'Homes are decorated with rangoli and diyas.',
      'The night sky lights up with fireworks.',
      'I am the festival of lights.',
    ],
  },
  {
    answer: 'Mahatma Gandhi', category: 'Personality',
    clues: [
      'I was born in Porbandar, Gujarat.',
      'I championed non-violence, or ahimsa.',
      'I led the famous Salt March.',
      'I am called the "Father of the Nation".',
    ],
  },
  {
    answer: 'Mount Everest', category: 'Place',
    clues: [
      'I sit on the border of Nepal and Tibet.',
      'I was first summited in 1953.',
      'Tenzing Norgay and Edmund Hillary reached my top.',
      'I am the tallest mountain on Earth.',
    ],
  },
  {
    answer: 'Virat Kohli', category: 'Cricket',
    clues: [
      'I was born in Delhi in 1988.',
      'I have captained India across all formats.',
      'I am famous for chasing down big run targets.',
      'My nickname is "King Kohli".',
    ],
  },
  {
    answer: 'The Great Wall of China', category: 'Monument',
    clues: [
      'I stretch for thousands of kilometres.',
      'I was built over many centuries.',
      'I was meant to keep invaders out.',
      'I am the most famous landmark in China.',
    ],
  },
  {
    answer: 'Charminar', category: 'Monument',
    clues: [
      'I was built in 1591.',
      'I have four grand arches and four minarets.',
      'I stand in the old city of Hyderabad.',
      'My name literally means "four towers".',
    ],
  },
  {
    answer: 'Yoga', category: 'Wellness',
    clues: [
      'I began in ancient India.',
      'I combine breathing with body postures.',
      '"Asana" and "pranayama" are part of me.',
      'June 21 is my International Day.',
    ],
  },
  {
    answer: 'Chess', category: 'Game',
    clues: [
      'I began in India as "Chaturanga".',
      'I am played on a board of 64 squares.',
      'Each side has a king and a queen.',
      '"Checkmate" ends the game.',
    ],
  },
  {
    answer: 'Shah Rukh Khan', category: 'Bollywood',
    clues: [
      'I was born in Delhi in 1965.',
      'I started on television before films.',
      'I am often called "King Khan".',
      'Fans know me as the "Badshah of Bollywood".',
    ],
  },
  {
    answer: 'The Eiffel Tower', category: 'Monument',
    clues: [
      'I was completed in 1889.',
      'I am made of wrought iron.',
      'I light up and sparkle every night.',
      'I am the icon of Paris.',
    ],
  },
  {
    answer: 'Cricket World Cup', category: 'Sport',
    clues: [
      'I am held once every four years.',
      'Teams from around the world compete for me.',
      'India lifted me in 1983 and 2011.',
      'I am cricket’s biggest ODI trophy.',
    ],
  },
];

export const GUESS_CATEGORY_COLORS = {
  Monument: '#0891b2',
  Cricket: '#16a34a',
  Personality: '#2563eb',
  Festival: '#ea580c',
  Place: '#7c3aed',
  Wellness: '#16a34a',
  Game: '#475569',
  Bollywood: '#db2777',
  Sport: '#16a34a',
};
